import type { LeaderboardEntry } from "@/app/achievements/page"
import LeaderboardEntryComponent from "./leaderboard-entry"

interface LeaderboardProps {
  entries: LeaderboardEntry[]
}

export default function Leaderboard({ entries }: LeaderboardProps) {
  return (
    <section>
      <h2 className="text-2xl font-bold mb-4 text-slate-900">Class Leaderboard</h2>
      <div className="bg-slate-100 p-2 sm:p-4 rounded-2xl shadow-sm border border-slate-200">
        <div className="space-y-2">
          {entries.map((entry) => (
            <LeaderboardEntryComponent key={entry.rank} entry={entry} />
          ))}
        </div>
      </div>
    </section>
  )
}
